import firebase from 'firebase';
import moment from "moment";
import * as polyline from "google-polyline";

export const setDatePeriod = (params) => {

    return async (dispatch) => {
        dispatch({
            type: "SET_DATE_PERIOD",
            payload: params,
        })
    };
};
export const setUserActivityHasStarted = () => {
    return async (dispatch) => {
        dispatch({
            type: "USER_ACTIVITY_HAS_STARTED",
        })
    };
};

export const cancelSearch = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: "CANCEL_SEARCH",
        });
    }
};
export const addRequest = (params) => {
    return async (dispatch, getState) => {
        let targetDeparturePosition = params.from && params.from.geometry.location;
        let targetArrivalPosition = params.to && params.to.geometry.location;

        // console.log( params.from);

        //Add route on map
        let route = {
            arrival: {
                city: params.to && params.to.name,
                location: [targetArrivalPosition.lat(), targetArrivalPosition.lng()],
            },
            departure: {
                city: params.from && params.from.name,
                location: [targetDeparturePosition.lat(), targetDeparturePosition.lng()],
                date: new Date(),
            },
            id: "request-" + targetDeparturePosition.lat() + "," + targetDeparturePosition.lng() + "-" + targetArrivalPosition.lat() + "," + targetArrivalPosition.lng(),
            request: true,
            requests: [{
                createdAt: new Date(),
                price: params.price || null,
                date: (params.date && params.date.valueOf()) || null,
            }],
            path: polyline.encode([
                [targetDeparturePosition.lat(), targetDeparturePosition.lng()],
                [targetArrivalPosition.lat(), targetArrivalPosition.lng()],
            ]),
        };


        let docRef = firebase.firestore().collection("legs").doc(route.id);
        let fbRoute = (await docRef.get()).data();
        if(!fbRoute){
            fbRoute = route;
            dispatch({
                type: "ADD_REQUESTED_ROUTE", payload: {
                    route
                },
            });
        } else {
            fbRoute.requests = [
                ...fbRoute.requests,
                ...route.requests,
                ];
            dispatch({
                type: "UPDATE_REQUESTED_ROUTE", payload: {
                    route,
                },
            });
        }
        await docRef.set(fbRoute);

    }
};
export const search = (params) => {
    return async (dispatch, getState) => {

        dispatch({
            type: "START_SEARCH",
        });

        const state = getState().interactiveMap;

        let targetDeparturePosition = params.from && params.from.geometry.location;
        let targetArrivalPosition = params.to && params.to.geometry.location;
        let routesWithDistancesWithinRadius = [];

        for (let route of state.routes) {
            let departurePosition = new window.google.maps.LatLng(route.departure.location.latitude, route.departure.location.longitude);
            let arrivalPosition = new window.google.maps.LatLng(route.arrival.location.latitude, route.arrival.location.longitude);

            if (route.request) {
                departurePosition = new window.google.maps.LatLng(route.departure.location[0], route.departure.location[1]);
                arrivalPosition = new window.google.maps.LatLng(route.arrival.location[0], route.arrival.location[1]);
            }

            let departureDistance = (targetDeparturePosition && window.google.maps.geometry.spherical.computeDistanceBetween(targetDeparturePosition, departurePosition)) || 0;
            let arrivalDistance = (targetArrivalPosition && window.google.maps.geometry.spherical.computeDistanceBetween(targetArrivalPosition, arrivalPosition)) || 0;

            if (
                (!departureDistance || departureDistance < params.radius) &&
                (!arrivalDistance || arrivalDistance < params.radius) &&
                (!params.date || Math.abs(params.date.diff(moment(route.departure.date), "days")) < params.dateRange)
            ) {
                console.log({
                    ...route, departureDistance, arrivalDistance
                });
                routesWithDistancesWithinRadius.push({
                    ...route, departureDistance, arrivalDistance
                })
            }
        }

        // if (routesWithDistancesWithinRadius.length === 0) {
        // }

        // console.log(routesWithDistancesWithinRadius);

        dispatch({
            type: "INTERACTIVE_SEARCH", payload: {
                params,
                routes: routesWithDistancesWithinRadius.map(route => route.id)
            },
        })

    }

};

export const fetchInteractiveMapRoutes = () => {
    return async (dispatch) => {
        dispatch({type: "FETCH_INTERACTIVE_MAP_ROUTES"});

        const now = moment();

        let routes = await firebase.firestore().collection("legs")
            .orderBy("departure.date")
            .get().then(snapshot => {
                let items = [];
                snapshot.forEach(doc => {
                    const item = doc.data();
                    item.id = doc.id;
                    item.hasDeparted = item.departure.date && moment(item.departure.date).isBefore(now);
                    if (!item.hasDeparted) {
                        items.push(item);
                    }
                });
                return items;
            });

        let ships = await firebase.firestore().collection("ships")
            .orderBy("name")
            .get().then(snapshot => {
                let items = [];
                snapshot.forEach(doc => {
                    const item = doc.data();
                    item.id = doc.id;
                    items.push(item);
                });
                return items;
            });


        dispatch({
            type: "FETCHED_INTERACTIVE_MAP_ROUTES", payload: {
                routes, ships
            }
        })


    };
};


// WEBPACK FOOTER //
// ./src/actions/InteractiveMapActions.js